import * as yup from 'yup'

import { SUGGESTED_FIELD_LENGTH } from '../../utils/Constants'
import { cleanPhone } from '../../utils/PhoneUtils'

const phoneLength = 10
const phoneValidation = yup
  .string()
  .transform(value => (value === '' ? null : value))
  .nullable()
  .test('is-phone', 'Phone number must be 10 digits', function (value) {
    if (!value) return true
    return cleanPhone(value).length === phoneLength
  })

// Minimum fields required to CREATE a case (Draft status).
// Additional fields required to ACTIVATE (In Progress) are enforced by the
// backend CaseIntakeCompleteAction: referral.date and referral.adjusterId.
const intakeSchema = yup.object().shape({
  caseTypeId: yup.number().label('Case Type').required('Case Type is required').typeError('Case Type is required'),
  client: yup.object().shape({
    firstName: yup
      .string()
      .label('Claimant first name')
      .required('Claimant first name is required')
      .max(SUGGESTED_FIELD_LENGTH),
    lastName: yup
      .string()
      .label('Claimant last name')
      .required('Claimant last name is required')
      .max(SUGGESTED_FIELD_LENGTH),
    birthdate: yup.string().label('Date of Birth').required('Date of Birth is required'),
    phone: phoneValidation,
    email: yup
      .string()
      .transform(value => (value === '' ? null : value))
      .nullable()
      .email('Claimant email must be a valid email address'),
  }),
  injury: yup.object().shape({
    date: yup.string().label('Date of Injury').required('Date of Injury is required'),
  }),
  referral: yup.object().shape({
    date: yup.string().label('Date of Referral').nullable(),
    sourceId: yup.number().label('Referral Source').nullable().typeError('Referral Source must be a valid selection'),
    adjusterId: yup.number().label('Adjuster').nullable().typeError('Adjuster must be a valid selection'),
    claimNumber: yup.string().label('Claim Number').nullable().max(SUGGESTED_FIELD_LENGTH),
  }),
})

export default {
  getForStep: () => intakeSchema,
}
